"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var IfElseCalculation_1 = require("./calculations/IfElseCalculation");
var SimplePredicateCalculation_1 = require("./calculations/SimplePredicateCalculation");
var RowShiftCalculation_1 = require("./calculations/RowShiftCalculation");
var TimeShiftCalculation_1 = require("./calculations/TimeShiftCalculation");
var ConstantCalculation_1 = require("./calculations/ConstantCalculation");
/**
 * The Default registry of named TransformCreator functions.
 *
 * New calculation types must be added here to be made available to `materializeTable`.
 */
exports.DefaultTransformRegistry = (_a = {},
    _a[TimeShiftCalculation_1.TimeShiftType] = TimeShiftCalculation_1.timeShiftTransformCreator,
    _a[RowShiftCalculation_1.RowShiftType] = RowShiftCalculation_1.rowShiftTransformCreator,
    _a[IfElseCalculation_1.IfElseType] = IfElseCalculation_1.ifElseTransformCreator,
    _a[SimplePredicateCalculation_1.SimplePredicateType] = SimplePredicateCalculation_1.simplePredicateTransformCreator,
    _a[ConstantCalculation_1.ConstantType] = ConstantCalculation_1.constantColumnTransformCreator,
    _a);
//# sourceMappingURL=DefaultTransformRegistry.js.map